import { localeOptions } from '../../constants/defaultValues';
import { defaultLocale } from '../../utils/translation';
import * as types from '../actions/types';
import LocalStorage from '../../utils/localStorage';

const storedLang = LocalStorage.getItem('lang');

const account = {
    requesting: false,
    data: null,
};

const initialState = {
    account,
    loading: false,
    locale:
        storedLang && localeOptions.filter(x => x.id === storedLang).length > 0
            ? storedLang
            : defaultLocale,
    theme: false,
    translationMode: false,
};

const settingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_USER_ACCOUNT_REQUEST:
            return { ...state, account: { ...state.account, requesting: true } };
        case types.GET_USER_ACCOUNT_SUCCESS:
            return {
                ...state,
                account: { ...state.account, requesting: false, data: action.payload },
            };
        case types.CHANGE_UNREAD_MESSAGE_COUNT: {
            return {
                ...state,
                account: {
                    ...state.account,
                    data: { ...state.account.data, messageCount: action.payload },
                },
            };
        }
        case types.SET_LOADING:
            return { ...state, loading: action.payload };
        case types.CHANGE_LOCALE:
            return { ...state, locale: action.payload };
        case types.CHANGE_THEME:
            return { ...state, theme: action.payload };
        case types.CHANGE_TRANSLATION_MODE:
            return { ...state, translationMode: action.payload };

        default:
            return state;
    }
};

export default settingsReducer;
